import React from 'react';
import { faDotCircle } from '@fortawesome/pro-regular-svg-icons/faDotCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function DotCircleRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faDotCircle} {...props} />;
}
